import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Tabs, TabList, Tab, TabPanel } from 'react-tabs';
import { connect } from 'react-redux';
import Modal from 'react-modal';

import { closeModal } from '../../../actions';
import HandleLogin from '../../../handlers/HandleLogin';
import HandleSignup from '../../../handlers/HandleSigup';

const customStyles = {
    content: {
        top: '50%',
        transform: 'translateY(-50%)'
    },
    overlay: {
        backgroundColor: 'rgba(77,77,77,0.6)',
        zIndex: '10000'
    }
};

Modal.setAppElement('#root');

function LoginModal(props) {
    const { showModal, modal } = props;
    let timer;
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");

    const [loginForm, setLoginForm] = useState({
        email: "",
        password: "",
        name: "",
        username: "",
        userType: "CUSTOMER",
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setLoginForm({
            ...loginForm,
            [name]: value,
        });
    };
    function closeModal() {
        document.getElementById("login-modal").classList.remove("ReactModal__Content--after-open");

        timer = setTimeout(() => {
            props.closeModal('login');
        }, 200);
    }
    useEffect(() => {
        // let Token = localStorage.getItem("Token")
        // if (Token) {
        //     closeModal()
        // }
        return () => {
            if (timer) clearTimeout(timer);
        }
    })

    const handleSubmit = (e) => {
        e.preventDefault();
        HandleLogin(
            username,
            password
        )
    };

    const OnSignup = (e) => {
        e.preventDefault();
        HandleSignup(loginForm)
    }

    let Token = localStorage.getItem("Token")
    // useEffect(() => {
    //     if (Token && showModal) {
    //         closeModal()
    //     }
    // }, [])

    return (
        <Modal
            isOpen={showModal && !Token === modal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Login Modal"
            className="modal-dialog modal-dialog-centered"
            id="login-modal" >
            <div className="modal-content">
                <div className="modal-body">
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={closeModal}>
                        <span aria-hidden="true"><i className="icon-close"></i></span>
                    </button>
                    <div className="form-box">
                        <div className="form-tab">
                            <Tabs selectedTabClassName="show" defaultIndex={0}>
                                <TabList className="nav nav-pills nav-fill">
                                    <Tab className="nav-item">
                                        <span className="nav-link">Sign In</span>
                                    </Tab>

                                    <Tab className="nav-item">
                                        <span className="nav-link">Register</span>
                                    </Tab>
                                </TabList>

                                <div className="tab-content">
                                    <TabPanel style={{ paddingTop: "2rem" }}>
                                        <div>
                                            <form onSubmit={(e) => handleSubmit(e)}>
                                                <div className="form-group">
                                                    <label htmlFor="singin-email-2">Username or email address *</label>
                                                    <input type="text" className="form-control" id="singin-email-2" name="singin-email" required value={username}
                                                        onChange={(e) => setUsername(e.target.value)} />
                                                </div>

                                                <div className="form-group">
                                                    <label htmlFor="singin-password-2">Password *</label>
                                                    <input type="password" className="form-control" id="singin-password-2" name="singin-password" required value={password}
                                                        onChange={(e) => setPassword(e.target.value)} />
                                                </div>

                                                <div className="form-footer">
                                                    <button type="submit" className="btn btn-outline-primary-2">
                                                        <span>LOG IN</span>
                                                        <i className="icon-long-arrow-right"></i>
                                                    </button>

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" className="custom-control-input" id="signin-remember-2" />
                                                        <label className="custom-control-label" htmlFor="signin-remember-2">Remember Me</label>
                                                    </div>

                                                    <Link to="#" className="forgot-link">Forgot Your Password?</Link>
                                                </div>
                                            </form>
                                            <div className="form-choice">
                                                <p className="text-center">or sign in with</p>
                                                <div className="row">
                                                    <div className="col-sm-6">
                                                        <Link to="#" className="btn btn-login btn-g">
                                                            <i className="icon-google"></i>
                                                            Login With Google
                                                        </Link>
                                                    </div>
                                                    <div className="col-sm-6">
                                                        <Link to="#" className="btn btn-login btn-f">
                                                            <i className="icon-facebook-f"></i>
                                                            Login With Facebook
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>

                                    <TabPanel>
                                        <form onSubmit={(e) => OnSignup(e)}>
                                            <div className='d-flex justify-content-between'>
                                                <div className="form-group" style={{ width: "48%" }}>
                                                    <label htmlFor="register-username-2">Username *</label>
                                                    <input type="text" className="form-control" id="register-username-2" name="username" value={loginForm.username}
                                                        onChange={handleInputChange} required />
                                                </div>
                                                <div className="form-group" style={{ width: "48%" }}>
                                                    <label htmlFor="register-name-2">Name *</label>
                                                    <input type="text" className="form-control" id="register-name-2" name="name" value={loginForm.name}
                                                        onChange={handleInputChange} required />
                                                </div>
                                            </div>
                                            <div className="form-group">
                                                <label htmlFor="register-email-2">Your email address *</label>
                                                <input type="email" className="form-control" id="register-email-2" name="email" value={loginForm.email} onChange={handleInputChange} required />
                                            </div>

                                            <div className="form-group">
                                                <label htmlFor="register-password-2">Password *</label>
                                                <input type="password" className="form-control" id="register-password-2" name="password" value={loginForm.password} onChange={handleInputChange} required />
                                            </div>

                                            <div className="form-footer">
                                                <button type="submit" className="btn btn-outline-primary-2">
                                                    <span>SIGN UP</span>
                                                    <i className="icon-long-arrow-right"></i>
                                                </button>

                                                <div className="custom-control custom-checkbox">
                                                    <input type="checkbox" className="custom-control-input" id="register-policy-2" required />
                                                    <label className="custom-control-label" htmlFor="register-policy-2">I agree to the <Link to="#">privacy policy</Link> *</label>
                                                </div>
                                            </div>
                                        </form>
                                        <div className="form-choice">
                                            <p className="text-center">or sign in with</p>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <Link to="#" className="btn btn-login btn-g">
                                                        <i className="icon-google"></i>
                                                        Login With Google
                                                    </Link>
                                                </div>
                                                <div className="col-sm-6">
                                                    <Link to="#" className="btn btn-login  btn-f">
                                                        <i className="icon-facebook-f"></i>
                                                        Login With Facebook
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </TabPanel>
                                </div>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        showModal: state.modal.showModal,
        modal: state.modal.modal
    }
}

export default connect(mapStateToProps, { closeModal })(LoginModal);